import { render } from "./ExpertChatInput.vue?vue&type=template&id=e19635a8&scoped=true"
import script from "./ExpertChatInput.vue?vue&type=script&lang=js"
export * from "./ExpertChatInput.vue?vue&type=script&lang=js"

import "./ExpertChatInput.vue?vue&type=style&index=0&id=e19635a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19635a8"]])

export default __exports__